<template>
  <div class="charts-page">

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="$t('menu.orcamentoFonteRecursos')">
          <iframePowerBI :fonte='fonte' @token-refresh="buscarLinkBi"> </iframePowerBI>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import iframePowerBI from '@/components/iframe/implementacoes/iframePowerBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'orcamento-fonte-recursos',
  components: {
    iframePowerBI,
    Sp360Panel,
  },
  data: () => ({
    fonte: {},
  }),
  created () {
    this.buscarLinkBi()
  },
  methods: {
    buscarLinkBi () {
      this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: constantes.LINK_IFRAME.ORCAMENTO.ORCAMENTO_FONTE_RECURSOS })
        .then((retorno) => {
          this.fonte = retorno.data
        }).catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>
